import { http } from './config'

export default {

  getTimeZones: () => {
    return http.get('timezones')
  },

  getAllUsers: () => {
    return http.get('users')
  },

  getUsersByRoleAndLocality: (role, locality) => {
    return http.get(`users/by_role/${role}/locality/${locality}`)
  },

  getFilteredUser: (params) => {
    return http.get('users', {params})
  },

  getUserById: (userId) => {
    return http.get('users/' + userId)
  },

  createUser: (userParams) => {
    return http.post('users', {
      "user":
        {
          login: userParams.login,
          password: userParams.password,
          name: userParams.name,
          cpf: userParams.cpf,
          email: userParams.email,
          timezone: userParams.timezone,
          locale: userParams.locale.code,
          active: userParams.active
        }
    })
  },

  updateUser: (userParams) => {
    return http.put('users/' + userParams.id, {
      "user":
        {
          login: userParams.login,
          password: userParams.password,
          name: userParams.name,
          cpf: userParams.cpf,
          email: userParams.email,
          timezone: userParams.timezone,
          locale: userParams.locale.code,
          active: userParams.active
        }
    })
},

  deleteUser: (userId) => {
    return http.delete('users/' + userId)
  }
}
